import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Tag, selectAdvisorState } from '..';

function convertEmailsToTags(emails: string[]): Tag[] {
  return emails.map(email => ({
    value: email,
    isValid: true,
    error: '',
  }));
}

export function useEmailTags(initialEmails: string[] = []) {
  const [emailTags, setEmailTags] = useState<Tag[]>(convertEmailsToTags(initialEmails));
  const [clearEmailWarnings, setClearEmailWarnings] = useState(false);
  const {
    advisorSettings: { isLoading, status },
  } = useSelector(selectAdvisorState);

  useEffect(() => {
    setEmailTags(convertEmailsToTags(initialEmails));
    setClearEmailWarnings(true);
    const timer = setTimeout(() => setClearEmailWarnings(false), 100);
    return () => clearTimeout(timer);
  }, [initialEmails]);

  // Handle success state to reset email warnings
  useEffect(() => {
    if (status === 'complete' && isLoading === false) {
      setClearEmailWarnings(true);
      const timer = setTimeout(() => setClearEmailWarnings(false), 100);
      return () => clearTimeout(timer);
    }
  }, [isLoading, status]);

  const handleEmailTagsChange = (emails: Tag[]) => {
    setEmailTags(emails);
  };

  const getValidEmails = () => {
    return emailTags
      .filter(email => email.isValid)
      .map(email => email.value);
  };

  const resetEmailTags = (emails: string[] = []) => {
    setEmailTags(convertEmailsToTags(emails));
    setClearEmailWarnings(true);
    setTimeout(() => setClearEmailWarnings(false), 100);
  };

  return {
    emailTags,
    clearEmailWarnings,
    handleEmailTagsChange,
    getValidEmails,
    resetEmailTags,
  };
}